import { LoadState } from "../../constants/enums";


export interface IOrgEnvConfigState {
	list: IOrgEnvConfig[];
	loading: LoadState;
	totalRecords: number;
}


export interface IOrgEnvConfig {
	company_outlet_env_uuid: string | null;
	env_name: string | null;
	env_key: string | null;
	env_value: string | null;
	is_encrypted: number;
	value_datatype: string;
	status: string;
	company_outlet_uuid: string | null;
}

export const initialOrgEnvConfigState: IOrgEnvConfigState = {
	list: [],
	loading: LoadState.NotLoaded,
	totalRecords: 0,
};

export const INITIAL_ORG_ENV_CONFIG: IOrgEnvConfig = {
	company_outlet_env_uuid: null,
	env_key: null,
	env_value: null,
	env_name: null,
	value_datatype: "0",
	is_encrypted: 0,
	status: "ACTIVE",
	company_outlet_uuid: null,
};
